import { render, staticRenderFns } from "./SelectCategory.vue?vue&type=template&id=e9dbd5c2&"
import script from "./SelectCategory.vue?vue&type=script&lang=js&"
export * from "./SelectCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports